// =============================================
// Validación cliente de leads públicos.
// Mismas reglas que sanitize.ts para feedback inmediato.
// =============================================

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_RE = /^[+0-9 ()\-.]{6,30}$/;
const MIN_PHONE_DIGITS = 7;
const MIN_NAME_LETTERS = 2;

function countLetters(s) {
  return (s.match(/\p{L}/gu) || []).length;
}

export function validateLead(values, form) {
  const nombre = (values.nombre || "").trim();
  if (!nombre) return "Indica tu nombre";
  if (countLetters(nombre) < MIN_NAME_LETTERS) {
    return "Indica un nombre válido";
  }

  const telefono = (values.telefono || "").trim();
  if (form.require_phone && !telefono) {
    return "Indica tu teléfono";
  }
  if (telefono) {
    if (!PHONE_RE.test(telefono)) {
      return "El teléfono solo puede contener números, espacios y los símbolos + ( ) - .";
    }
    const digits = telefono.replace(/\D/g, "").length;
    if (digits < MIN_PHONE_DIGITS) {
      return "El teléfono es demasiado corto";
    }
  }

  const email = (values.email || "").trim();
  if (form.require_email && !email) {
    return "Indica tu email";
  }
  if (email && !EMAIL_RE.test(email)) {
    return "El email no parece válido";
  }

  return null;
}
